import {throttle} from '../modules/throttle';

var dynamicIframe = function(wrapper){
	var param = JSON.parse(wrapper.getAttribute('data-param')),
        iframe = wrapper.querySelector('[data-dynamicIframe-element]'),
        uid = new Date().getTime() + Math.random(),
        data = JSON.stringify({"uid": uid, "module": "dynamicIframe"}),
        checkData = function(data){
            try {
                var data = JSON.parse(data);
            } catch(e){
                return false;
            }
            if(data.module !== 'dynamicIframe' || (data.uid !== uid)) return false;
            return data;
        },
        onMessage = function(data){
            var data = checkData(data.data);
            if(!data) return;
            wrapper.style.height = data.h + 'px';
            wrapper.classList.add('js-active');
        },
		onLoad = function(){
            iframe.contentWindow.postMessage(data, '*');
		},
		init = function(){
			iframe.src = param.src;
            iframe.addEventListener('load', onLoad);
            window.addEventListener('message', onMessage);
		};

	//
    if(!iframe) return;
	init();
}

export {dynamicIframe};
